import { render, staticRenderFns } from "./ChangeItemDetails.vue?vue&type=template&id=0f6c6716&scoped=true"
import script from "./ChangeItemDetails.vue?vue&type=script&lang=js"
export * from "./ChangeItemDetails.vue?vue&type=script&lang=js"
import style0 from "./ChangeItemDetails.vue?vue&type=style&index=0&id=0f6c6716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c6716",
  null
  
)

export default component.exports